module.exports = __webpack_public_path__ + "static/media/3.2755b906.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3.jpg
// module id = 76
// module chunks = 0